import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/common/Button';

const AboutStory = () => {
  const storyRef = useRef(null);
  
  useEffect(() => {
    if (!storyRef.current) return;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Görünür olduğunda animasyonları başlat
          entry.target.querySelectorAll('.animate-on-scroll').forEach((el, index) => {
            setTimeout(() => {
              el.classList.add('animate-fadeIn');
            }, index * 200); // Her öğeyi sırayla göster
          });
          observer.unobserve(entry.target); // Bir kez görüldüğünde gözlemlemeyi bırak
        }
      });
    }, { threshold: 0.2 }); // Öğenin %20'si göründüğünde tetikle
    
    observer.observe(storyRef.current);
    
    return () => {
      if (storyRef.current) {
        observer.unobserve(storyRef.current);
      }
    };
  }, []);

  return (
    <div ref={storyRef} className="p-6 sm:p-10 overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
        <div>
          <h2 className="animate-on-scroll opacity-0 text-3xl font-bold text-gray-900 mb-6 flex items-center">
            <span className="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center mr-3">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </span>
            Hikayemiz
          </h2>
          <div className="space-y-4">
            <p className="animate-on-scroll opacity-0 text-gray-600">
              İYTE Müzik Topluluğu, 2015 yılında bir grup müzik tutkunu öğrenci tarafından kuruldu. Başlangıçta sadece birkaç enstrümanla başlayan topluluğumuz, bugün tam donanımlı bir müzik odası ve 200'den fazla aktif üyeye sahip.
            </p>
            <p className="animate-on-scroll opacity-0 text-gray-600">
              Amacımız, yoğun akademik programların içinde öğrencilere müzikle nefes alabilecekleri bir alan sunmak ve müzik tutkusunu kampüs geneline yaymak.
            </p>
            <p className="animate-on-scroll opacity-0 text-gray-600">
              Topluluğumuz, İYTE'nin farklı bölümlerinden öğrencileri bir araya getiriyor. Teknik bir üniversitede bile sanatın ve müziğin insan hayatındaki öneminin altını çizerek, kampüs yaşamına renk katmaya çalışıyoruz.
            </p>
          </div>
          <div className="mt-6 animate-on-scroll opacity-0">
            <Link to="/contact">
              <Button variant="outline" className="hover:scale-105 transition-transform duration-300">
                Bize Ulaşın
              </Button>
            </Link>
          </div>
        </div>
        <div className="relative h-80 lg:h-auto animate-on-scroll opacity-0">
          <div className="absolute inset-0 rounded-lg overflow-hidden shadow-xl transform transition-all duration-500 hover:scale-[1.02] hover:shadow-2xl">
            <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/20 to-purple-500/20 z-10"></div>
            <img 
              className="absolute inset-0 w-full h-full object-cover"
              src="/api/placeholder/800/600" 
              alt="İYTE Müzik Topluluğu üyeleri bir etkinlikte"
            />
          </div>
        </div>
      </div>
      
      {/* Custom animation styles */}
      <style jsx>{`
        .animate-fadeIn {
          animation: fadeIn 0.8s ease forwards;
        }
        
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default AboutStory;